import axios from 'axios';
import { getListPage, delData, save } from '../../api/api';

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};
var _utilThisObj;
export default {
	isJson:function(obj){
		var isjson = typeof(obj) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length; 
		return isjson ;
	},
	getOptArrayJson:function(opts,val){
		if(val==undefined||val==""){
			return opts;
		}
		try{
			var pyvalUp = val.toUpperCase();
			var rearray = [];
			for(var p in opts){
				if(opts[p].label.indexOf(val)>=0) {
					rearray.push(opts[p]);
				}
				if(opts[p].hasOwnProperty("label_p")){
					var pyin = opts[p].label_p;
					//console.log("check:"+pyin+">>"+pyvalUp);
					if(pyin.indexOf(pyvalUp)>=0) {
						rearray.push(opts[p]);
						//console.log("add:"+opts[p].label_p);
					}
				}
				
			}
			return rearray;
		}catch(e){
			console.log(e);
		}
		return opts;
	},
	getOptJson:function(opts,val){
		if(val==undefined){
			return {};
		}
		try{
			var rejson = {};
			for(var p in opts){
				if(opts[p].value==val) {
					rejson = opts[p];
					break ;
				}
			}
			return rejson;
		}catch(e){}
		return {};
	},
	getOptsLabelByVal:function(opts,val){
		if(val==undefined){
			return "空";
		}
		try{
			var restr = "";
			for(var p in opts){
				if(opts[p].value==val) {
					restr =  "("+opts[p].value+")"+opts[p].label;
					break ;
				}
			}
			return restr;
		}catch(e){}
		return val+":未知";
	},
	getOptsLabelByValNoKey:function(opts,val){
		if(val==undefined){
			return "空";
		}
		try{
			var restr = "";
			for(var p in opts){
				if(opts[p].value==val) {
					restr =  opts[p].label;
					break ;
				}
			}
			return restr;
		}catch(e){}
		return val+":未知";
	},
	getOpInfo:function(op){
		if(op=='1') return '移动';
		if(op=='2') return '联通';
		if(op=='3') return '电信';
		return '未知';
	},
	//获取Option 信息
	getOptsList:function(thisObj,param,callback)
	{
		let para = {actionurl:'default/getListAll',hasPyinKs:"label"};
		for(var key in param){
			para[key] = param[key];
	　　}
		//if(param.keyname!=undefined) para.actionurl = 'default/getKeyList';
		//console.log("GET OPTS:"+para.actionurl+">>["+param.keyname+"]");
		//axios.get(`${base}/`+params.actionurl, { params: params });		
		getListPage(para).then((res) => {
			if(!this.checkLogOut(thisObj,res.data)){
				callback(res.data.datas);
			}
		});
	},
	getKeyOptsList:function(thisObj,param,callback)
	{
		let para = {actionurl:'default/getKeyList'};
		for(var key in param){
			para[key] = param[key];
	　　}
		getListPage(para).then((res) => {
			if(!this.checkLogOut(thisObj,res.data)){
				callback(res.data);
			}
		});
	},
	doLogOut:function(){
		console.log("run LogOut..."+_utilThisObj);
		_utilThisObj.$router.push('/LoginOut');
	},
	checkLogOut:function(thisObj,data){
		if(data.status==-200){
			thisObj.$message({
				message: data.message,
				type: data.type
			});
			_utilThisObj = thisObj;
			setTimeout(this.doLogOut,100);
			return true;
		}
		return false;
	},
	update:function(thisObj,param){
		thisObj.listLoading = true;
		save(param).then((res) => {
			thisObj.listLoading = false;
			thisObj.$message({
				message: res.data.message,
				type: res.data.type
			});
			thisObj.getLists();
		});
	},
	deleteFunction:function(thisObj,param){
		thisObj.$confirm('确认删除该记录吗?', '提示', {
			type: 'warning'
		}).then(() => {
			thisObj.listLoading = true;
			delData(param).then((res) => {
				thisObj.listLoading = false;
				thisObj.$message({
					message: res.data.message,
					type: res.data.type
				});
				thisObj.getLists();
			});
		}).catch(() => {

		});
	},
	saveData:function(thisObj,param,callback){
		//数据保存
		thisObj.$refs.editForm.validate((valid) => {
			if (valid) {
				thisObj.$confirm('确认提交吗？', '提示', {}).then(() => {
					thisObj.editLoading = true;
					save(param).then((res) => {
						thisObj.editLoading = false;
						thisObj.$message({
							message: res.data.message,
							type: res.data.type
						});
						thisObj.$refs['editForm'].resetFields();
						thisObj.editFormVisible = false;
						callback();
					});
				});
			}
		});
	},
	saveFunction:function(thisObj,param){
		thisObj.$refs.editForm.validate((valid) => {
			if (valid) {
				thisObj.$confirm('确认提交吗？', '提示', {}).then(() => {
					thisObj.editLoading = true;
					//NProgress.start();
					save(param).then((res) => {
						thisObj.editLoading = false;
						thisObj.$message({
							message: res.data.message,
							type: res.data.type
						});
						//NProgress.done();
						if(res.data.type=='success'){
							thisObj.$refs['editForm'].resetFields();
							thisObj.editFormVisible = false;
							thisObj.getLists();
						}
					});
				}).catch(() => {
					//thisObj.$refs['editForm'].resetFields();
				});
			}else{
				//thisObj.$refs['editForm'].resetFields();
				
			}
		});
	},
	saveParamFunction:function(thisObj,param,editLoadingStr,editFormStr,editFormVisibleStr){
		thisObj.$refs.editForm.validate((valid) => {
			if (valid) {
				thisObj.$confirm('确认提交吗？', '提示', {}).then(() => {
					thisObj.editLoading = true;
					//NProgress.start();
					save(param).then((res) => {
						thisObj[editLoadingStr] = false;
						thisObj.$message({
							message: res.data.message,
							type: res.data.type
						});
						//NProgress.done();
						if(res.data.type=='success'){
							thisObj.$refs[editFormStr].resetFields();
							thisObj[editFormVisibleStr] = false;
							thisObj.getLists();
						}
					});
				}).catch(() => {
					//thisObj.$refs['editForm'].resetFields();
				});
			}else{
				//thisObj.$refs['editForm'].resetFields();
				
			}
		});
	},
	saveNotipFunction:function(thisObj,param){
		thisObj.$refs.editForm.validate((valid) => {
			if (valid) {
				try {
					thisObj.editLoading = true;
					//NProgress.start();
					save(param).then((res) => {
						thisObj.editLoading = false;
						thisObj.$message({
							message: res.data.message,
							type: res.data.type
						});
						//NProgress.done();
						if(res.data.type=='success'){
							thisObj.$refs['editForm'].resetFields();
							thisObj.editFormVisible = false;
							thisObj.getLists();
						}
					});
				}catch(erreo){
					//thisObj.$refs['editForm'].resetFields();
				}
			}else{
				//thisObj.$refs['editForm'].resetFields();
				
			}
		});
	},
	saveByFormFunction:function(thisObj,thisForm,param){
		thisObj.$refs[thisForm].validate((valid) => {
			if (valid) {
				thisObj.$confirm('确认提交吗？', '提示', {}).then(() => {
					thisObj.editLoading = true;
					//NProgress.start();
					save(param).then((res) => {
						thisObj.editLoading = false;
						thisObj.$message({
							message: res.data.message,
							type: res.data.type
						});
						//NProgress.done();
						if(res.data.type=='success'){
							//thisObj.$refs['editForm'].resetFields();
							thisObj.$refs[thisForm].resetFields();
							//thisForm.resetFields();
							thisObj.editFormVisible = false;
							thisObj.getLists();
						}
					});
				}).catch(() => {
					//thisObj.$refs['editForm'].resetFields();
				});
			}else{
				//thisObj.$refs['editForm'].resetFields();
				
			}
		});
	},
	saveNewByFormFunction:function(thisObj,thisForm,param){
		thisObj.$refs[thisForm].validate((valid) => {
			if (valid) {
				thisObj.$confirm('确认提交吗？', '提示', {}).then(() => {
					thisObj.editLoading = true;
					//NProgress.start();
					save(param).then((res) => {
						thisObj.editLoading = false;
						thisObj.$message({
							message: res.data.message,
							type: res.data.type
						});
						//NProgress.done();
						if(res.data.type=='success'){
							//thisObj.$refs['editForm'].resetFields();
							thisObj.$refs[thisForm].resetFields();
							//thisForm.resetFields();
							thisObj.newEditFormVisible = false;
							thisObj.getLists();
						}
					});
				}).catch(() => {
					//thisObj.$refs['editForm'].resetFields();
				});
			}else{
				//thisObj.$refs['editForm'].resetFields();
				
			}
		});
	},
	saveFunctionTabs:function(thisObj,param){
		thisObj.$refs.editForm.validate((valid) => {
			if (valid) {
				thisObj.$confirm('确认提交吗？', '提示', {}).then(() => {
					thisObj.editLoading = true;
					save(param).then((res) => {
						thisObj.editLoading = false;
						thisObj.$message({
							message: res.data.message,
							type: res.data.type
						});
						//NProgress.done();
						//thisObj.$refs['editForm'].resetFields();
						//thisObj.editFormVisible = false;
						thisObj.cancelTabPanel();
						thisObj.getLists();
					});
				}).catch(() => {
					//thisObj.$refs['editForm'].resetFields();
				});
			}else{
				//thisObj.$refs['editForm'].resetFields();
				
			}
		});
	},
	checkstatus:function(thepage,status){
		if(status==-200){
			console.log("需要重新登录");
			thepage.$confirm('登录超时！请重新登录!', '提示', {type: 'warning'}).then(() => {
				var _this = thepage;
				sessionStorage.removeItem('user');
				_this.$router.push('/login');				
			}).catch(() => {

			});
		}
	},
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {
		formatDateTime:function(date, format) {
			const o = {
				'M+': date.getMonth() + 1, // 月份
				'd+': date.getDate(), // 日
				'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
				'H+': date.getHours(), // 小时
				'm+': date.getMinutes(), // 分
				's+': date.getSeconds(), // 秒
				'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
				S: date.getMilliseconds(), // 毫秒
				a: date.getHours() < 12 ? '上午' : '下午', // 上午/下午
				A: date.getHours() < 12 ? 'AM' : 'PM', // AM/PM
			};
			if (/(y+)/.test(format)) {
				format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
			}
			for (let k in o) {
				if (new RegExp('(' + k + ')').test(format)) {
					format = format.replace(
					RegExp.$1,
					RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
				);
				}
			}
		  return format;
		},
        format: function (date, pattern) {
			console.log("date="+date+"..."+pattern);
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        },
		getdatestr:function(days,pattern){
			var nowDate = new Date(new Date().toLocaleDateString());
			return this.formatDateTime(new Date(nowDate.getTime()+days*24*60*60*1000),pattern);
			//return this.format(new Date(nowDate.getTime()+days*24*60*60*1000),pattern);
		},
		getNow:function(){
			return this.formatDateTime(new Date(),'yyyy-MM-dd hh:mm');
			//return this.format(new Date(nowDate.getTime()+days*24*60*60*1000),pattern);
		},
		getPatternNow:function(pattern){
			return this.formatDateTime(new Date(),pattern);
			//return this.format(new Date(nowDate.getTime()+days*24*60*60*1000),pattern);
		}
    }

};



// WEBPACK FOOTER //
// ./src/common/js/util.js